var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboardB(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "fi_3524878"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 1000003656"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M24.3958 4H5.60417C4.71958 4 4 4.71958 4 5.60417V7.89583C4 8.78042 4.71958 9.5 5.60417 9.5H24.3958C25.2804 9.5 26 8.78042 26 7.89583V5.60417C26 4.71958 25.2804 4 24.3958 4Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M5.60417 25.9999H12.4792C13.3637 25.9999 14.0833 25.2803 14.0833 24.3958V12.9374C14.0833 12.0528 13.3637 11.3333 12.4792 11.3333H5.60417C4.71958 11.3333 4 12.0528 4 12.9374V24.3958C4 25.2803 4.71958 25.9999 5.60417 25.9999Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M24.3952 11.3333H17.5202C16.6356 11.3333 15.916 12.0528 15.916 12.9374V16.1458C15.916 17.0303 16.6356 17.7499 17.5202 17.7499H24.3952C25.2798 17.7499 25.9993 17.0303 25.9993 16.1458V12.9374C25.9993 12.0528 25.2798 11.3333 24.3952 11.3333Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M24.3952 19.5833H17.5202C16.6356 19.5833 15.916 20.3028 15.916 21.1874V24.3958C15.916 25.2803 16.6356 25.9999 17.5202 25.9999H24.3952C25.2798 25.9999 25.9993 25.2803 25.9993 24.3958V21.1874C25.9993 20.3028 25.2798 19.5833 24.3952 19.5833Z",
    fill: "black"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardB);
export default __webpack_public_path__ + "static/media/dashboard_b.596a84bd606357e8804ffdd8c2983db4.svg";
export { ForwardRef as ReactComponent };